import styled, { css } from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';
import colors from 'Styles/colors';
import { ReactComponent as FiltersOn } from 'Images/icon_filter_on.svg';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
TitleWrapper.displayName = 'TitleWrapper';

export const TitleContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
TitleContainer.displayName = 'TitleContainer';

export const Title = styled.p`
  color: ${({ theme }) => theme.text.dashboardTitle};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
Title.displayName = 'Title';

export const TitleInfo = styled.div`
  color: ${({ theme }) => theme.text.dashboardLightTitle};
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;
TitleInfo.displayName = 'TitleInfo';

export const LinkButton = styled.button`
  font-size: 12px;
  font-style: normal;
  font-weight: 360;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.buttons.primary.background};
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    color: ${({ theme }) => theme.buttons.primary.border};
  }
`;
LinkButton.displayName = 'LinkButton';

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.dashboardLightTitle};
  border: 1px solid ${({ theme }) => theme.borders.tableHeaderBottom};
  background: transparent;
  border-radius: 999px;
  padding: 7px 12px 7px 10px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.buttons.primary.background};
    border-color: ${({ theme }) => theme.buttons.primary.background};
  }

  ${({ $active, theme }) => $active && css`
    color: ${theme.buttons.primary.background};
    border-color: ${theme.buttons.primary.background};
    background: color-mix(in srgb, ${theme.buttons.primary.background} 12%, transparent);
  `}
`;
FilterButton.displayName = 'FilterButton';

export const FilterIcon = styled(FiltersOn)`
  width: 17px;
  height: auto;
  flex-shrink: 0;
  & path {
    fill: currentColor;
    stroke: currentColor;
  }
  & circle {
    fill: none;
  }
`;
FilterIcon.displayName = 'FilterIcon';

export const FilterChevron = styled(FaChevronDown)`
  width: 9px;
  height: 9px;
  flex-shrink: 0;
`;
FilterChevron.displayName = 'FilterChevron';

export const FilterCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 15px;
  height: 15px;
  padding: 0 4px;
  border-radius: 999px;
  background: ${({ theme }) => theme.buttons.primary.background};
  color: ${({ theme }) => theme.buttons.primary.color};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: normal;
  text-transform: none;
`;
FilterCount.displayName = 'FilterCount';

export const FilterClear = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  font-size: 15px;
  line-height: 1;
  color: inherit;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;
FilterClear.displayName = 'FilterClear';

export const Empty = styled.div`
  user-select: none;
  color: ${colors.grey5};
  display: inline;
  font-size: 15px;
  font-weight: 300;
  margin-top: 8px;
`;
Empty.displayName = 'Empty';

export const FilterDropdownWrapper = styled.div`
  position: relative;
`;
FilterDropdownWrapper.displayName = 'FilterDropdownWrapper';

export const FilterDropdownSelector = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 100;
  background: ${({ theme }) => theme.backgrounds.modal};
  border: 1px solid ${({ theme }) => theme.borders.tableHeaderBottom};
  border-radius: 4px;
  padding: 4px 0;
  width: max-content;
  min-width: 130px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;
FilterDropdownSelector.displayName = 'FilterDropdownSelector';

export const FilterDropdownOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 15px;
  white-space: nowrap;
  color: ${({ theme }) => theme.text.dashboardTitle};
  &:hover {
    background: ${({ theme }) => theme.backgrounds.secondary};
  }
`;
FilterDropdownOption.displayName = 'FilterDropdownOption';
